import { SUBSCRIPTION_TRIAL_PERIOD_PAYROLL_RUNS } from "constants/subscription/trial";

import { GetCompanyByIdResponseDto } from "utils/swagger_react_query";

export const hasCompanyActiveFreeTrial = (
  company: GetCompanyByIdResponseDto | null | undefined,
): boolean => {
  if (!company?.freeTrialAgreedAt || isCompanyTrialEnded(company)) return false;

  return (
    (company?.completedPayrollsAfterFreeTrialStarted || 0) < SUBSCRIPTION_TRIAL_PERIOD_PAYROLL_RUNS
  );
};

export const isCompanyWithinTrialPayrollLimit = (
  company: GetCompanyByIdResponseDto | null | undefined,
): boolean => {
  if (!hasCompanyActiveFreeTrial(company)) return false;

  return (
    (company?.completedPayrollsAfterFreeTrialStarted || 0) < SUBSCRIPTION_TRIAL_PERIOD_PAYROLL_RUNS
  );
};

export const hasCompanyActiveSubscription = (
  company: GetCompanyByIdResponseDto | null | undefined,
): boolean => {
  if (!company) return false;

  return !!company?.isSubscribed;
};

export const hasCompanyActiveSubscriptionOrTrial = (
  company: GetCompanyByIdResponseDto | null | undefined,
): boolean => {
  return hasCompanyActiveFreeTrial(company) || hasCompanyActiveSubscription(company);
};

export const isCompanyTrialEnded = (company: GetCompanyByIdResponseDto | null | undefined) => {
  if (!company?.freeTrialAgreedAt) return false;

  return (
    !!company?.completedPayrollsAfterFreeTrialStarted &&
    company?.completedPayrollsAfterFreeTrialStarted >= SUBSCRIPTION_TRIAL_PERIOD_PAYROLL_RUNS
  );
};

export const isCompanyTrialEndingSoon = (company: GetCompanyByIdResponseDto | null | undefined) => {
  if (!company?.freeTrialAgreedAt || !hasCompanyActiveFreeTrial(company)) return false;

  const trialEndingSoon =
    company?.completedPayrollsAfterFreeTrialStarted === SUBSCRIPTION_TRIAL_PERIOD_PAYROLL_RUNS - 1;

  return trialEndingSoon;
};

export const isSubscriptionRenewalRequired = (
  company: GetCompanyByIdResponseDto | null | undefined,
) => {
  if (!company?.freeTrialAgreedAt) return false;

  return !hasCompanyActiveSubscription(company) && isCompanyTrialEnded(company);
};

export const hasFreeTrialStarted = (company: GetCompanyByIdResponseDto | null | undefined) => {
  if (!company?.freeTrialAgreedAt) return true;

  return false;
};

export const canViewSubscriptionPage = (company: GetCompanyByIdResponseDto | null | undefined) => {
  return (
    isSubscriptionRenewalRequired(company) ||
    hasFreeTrialStarted(company) ||
    hasCompanyActiveFreeTrial(company)
  );
};

export const isSubscriptionPaymentFailed = (
  company: GetCompanyByIdResponseDto | null | undefined,
) => {
  return !!company?.paymentFailedAt;
};
